import React, { forwardRef } from "react";
import styles from "../Styles/ui/Input.module.css";

const Input = forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={`${styles.input} ${className}`}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
